"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcRunnitTokensToRdBalance = exports.calcRdBalanceToRunnitTokens = exports.RUNNIT_PLANS_TOKENS_CONVERSION_PRICE = exports.determineNextFreeRunnitTokensTopUpAt = exports.computeRenewalRolloverPlan = exports.isBelowAutoTopUpThreshold = exports.AUTO_TOP_UP_PROCESSING_STALE_MINUTES = exports.AUTO_TOP_UP_COOLDOWN_MINUTES = exports.openingCycleRunnitTokensBasisForTransfer = exports.renewalCycleRunnitTokensBasis = exports.calcEnterpriseTokenUsage = exports.determineRecurringRunnitTokensToAdd = exports.determineRecurringBalanceAmountToAdd = exports.DEFAULT_TEAM_RECURRING_CAP = exports.DEFAULT_TEAM_RECURRING_ALLOTMENT = exports.DEFAULT_CREATORS_CLUB_RECURRING_CAP = exports.DEFAULT_CREATORS_CLUB_RECURRING_ALLOTMENT = exports.processImmediateCorrectionsToFreeRunnitTokens = exports.calcRunnitTokensDataForBalanceAccount = exports.RUNNIT_BONUS_NUM_REFERRALS = exports.DAILY_FREE_RUNNIT_TOKENS_CAP = exports.DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL = exports.DAILY_FREE_RUNNIT_TOKENS_BASE = exports.IMMEDIATE_RUNNIT_TOKENS_SOCIAL_CONNECTION = exports.IMMEDIATE_RUNNIT_TOKENS_BASE = exports.LEGACY_TRIAL_FREE_RUNDIFFUSION_BALANCE_ALLOTMENT = exports.calcRealtimeBalanceInfo = void 0;
const lodash_1 = require("lodash");
const bignumber_js_1 = require("bignumber.js");
const pricing_1 = require("./pricing");
const moment = require('moment-timezone');
const calcRealtimeBalanceInfo = (balanceAccount) => {
    if (!balanceAccount) {
        return {
            realtimeBalance: 0,
            realtimeRecurringBalance: 0,
            realtimeRunnitTokens: 0,
            realtimeFreeRunnitTokens: 0,
        };
    }
    const propKeys = (0, lodash_1.keys)(balanceAccount);
    return propKeys.reduce((result, key) => {
        const delta = balanceAccount[key] || 0;
        if (key.startsWith('balance_delta_')) {
            return {
                ...result,
                realtimeBalance: result.realtimeBalance + delta
            };
        }
        if (key.startsWith('recurringBalance_delta_')) {
            return {
                ...result,
                realtimeRecurringBalance: result.realtimeRecurringBalance + delta
            };
        }
        if (key.startsWith('runnitTokens_delta_')) {
            return {
                ...result,
                realtimeRunnitTokens: result.realtimeRunnitTokens + delta
            };
        }
        if (key.startsWith('freeRunnitTokens_delta_')) {
            return {
                ...result,
                realtimeFreeRunnitTokens: result.realtimeFreeRunnitTokens + delta
            };
        }
        return result;
    }, {
        realtimeBalance: balanceAccount.balance || 0,
        realtimeRecurringBalance: balanceAccount.recurringBalance || 0,
        realtimeRunnitTokens: balanceAccount.runnitTokens || 0,
        realtimeFreeRunnitTokens: balanceAccount.freeRunnitTokens || 0,
    });
};
exports.calcRealtimeBalanceInfo = calcRealtimeBalanceInfo;
/* RunDiffusion Balance */
// No longer granted: signups get Runnit tokens only (IMMEDIATE_RUNNIT_TOKENS_BASE). Kept so cron5min can still
// expire the 30 cents older accounts received at signup once they are a year old.
exports.LEGACY_TRIAL_FREE_RUNDIFFUSION_BALANCE_ALLOTMENT = 30;
/* Runnit Tokens */
exports.IMMEDIATE_RUNNIT_TOKENS_BASE = (0, pricing_1.tokensToHundredths)(600);
exports.IMMEDIATE_RUNNIT_TOKENS_SOCIAL_CONNECTION = (0, pricing_1.tokensToHundredths)(100);
exports.DAILY_FREE_RUNNIT_TOKENS_BASE = (0, pricing_1.tokensToHundredths)(100);
exports.DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL = (0, pricing_1.tokensToHundredths)(50);
exports.DAILY_FREE_RUNNIT_TOKENS_CAP = (0, pricing_1.tokensToHundredths)(600);
exports.RUNNIT_BONUS_NUM_REFERRALS = Math.floor((exports.DAILY_FREE_RUNNIT_TOKENS_CAP - exports.DAILY_FREE_RUNNIT_TOKENS_BASE) / exports.DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL); // number of allowed referrals
const calcRunnitTokensDataForBalanceAccount = (balanceAccount, freemiumInfo, clubOffer) => {
    if (!balanceAccount) {
        return {
            combinedTokens: 0,
            runnitTokens: 0,
            freeRunnitTokens: 0,
            freeRunnitTokensTopUpAmount: 0,
            isFreemiumPassportValid: false,
            dailyFreeRunnitTokensAllotmentIfValid: exports.DAILY_FREE_RUNNIT_TOKENS_BASE,
        };
    }
    const { realtimeRunnitTokens, realtimeFreeRunnitTokens, } = (0, exports.calcRealtimeBalanceInfo)(balanceAccount);
    // Only factor in free tokens if freemium passport is active
    const isFreemiumPassportValid = !!(balanceAccount.type === 'USER' &&
        ((clubOffer && !clubOffer.isFreemium) ||
            (freemiumInfo && freemiumInfo.runnitFreemiumPassportId)));
    const runnitTokens = realtimeRunnitTokens;
    const freeRunnitTokens = isFreemiumPassportValid ? realtimeFreeRunnitTokens : 0;
    let dailyFreeRunnitTokensAllotmentIfValid = exports.DAILY_FREE_RUNNIT_TOKENS_BASE;
    if (isFreemiumPassportValid) {
        /*
        Calculate referral bonus tokens - each referral gives additional daily tokens
        */
        // Calculate how many referrals the user has
        const referralCount = freemiumInfo.referralUserInfos ? Object.keys(freemiumInfo.referralUserInfos).length : 0;
        // Check if the user has accepted a referral code to give them a bonus as well
        // We'll add +1 to effective referral count if they've accepted a referral code
        // This gives them the 25 daily token bonus too
        const hasAcceptedReferral = !!freemiumInfo.acceptedReferralCode;
        const effectiveReferralCount = referralCount + (hasAcceptedReferral ? 1 : 0);
        const referralBonusTokens = effectiveReferralCount > 0 ?
            Math.min(effectiveReferralCount * exports.DAILY_FREE_RUNNIT_TOKENS_PER_REFERRAL, exports.DAILY_FREE_RUNNIT_TOKENS_CAP) : 0;
        dailyFreeRunnitTokensAllotmentIfValid += referralBonusTokens;
    }
    const freeRunnitTokensTopUpAmount = isFreemiumPassportValid
        ? (0, lodash_1.clamp)(dailyFreeRunnitTokensAllotmentIfValid - Math.max(runnitTokens, 0) - Math.max(freeRunnitTokens, 0), 0, dailyFreeRunnitTokensAllotmentIfValid)
        : 0;
    return {
        combinedTokens: runnitTokens + freeRunnitTokens,
        runnitTokens,
        freeRunnitTokens,
        freeRunnitTokensTopUpAmount,
        isFreemiumPassportValid,
        dailyFreeRunnitTokensAllotmentIfValid,
    };
};
exports.calcRunnitTokensDataForBalanceAccount = calcRunnitTokensDataForBalanceAccount;
/*
Immediate corrections to user's `freeRunnitTokens` if necessary (immediate, meaning not scheduling a top-up for tonight end of day)
*/
const processImmediateCorrectionsToFreeRunnitTokens = (userId, balanceAccount, freemiumInfo, clubOffer, freeRunnitTokensTopUpAt) => {
    const { freeRunnitTokens, freeRunnitTokensTopUpAmount, dailyFreeRunnitTokensAllotmentIfValid, } = (0, exports.calcRunnitTokensDataForBalanceAccount)(balanceAccount, freemiumInfo, clubOffer);
    if (!freeRunnitTokensTopUpAt &&
        (freeRunnitTokensTopUpAmount ||
            freeRunnitTokens > dailyFreeRunnitTokensAllotmentIfValid)) {
        // freeRunnitTokens corrected amount
        return freeRunnitTokensTopUpAmount || (dailyFreeRunnitTokensAllotmentIfValid - freeRunnitTokens);
    }
    return 0;
};
exports.processImmediateCorrectionsToFreeRunnitTokens = processImmediateCorrectionsToFreeRunnitTokens;
exports.DEFAULT_CREATORS_CLUB_RECURRING_ALLOTMENT = 1000;
exports.DEFAULT_CREATORS_CLUB_RECURRING_CAP = 3000;
exports.DEFAULT_TEAM_RECURRING_ALLOTMENT = 0;
exports.DEFAULT_TEAM_RECURRING_CAP = 6000;
const determineRecurringBalanceAmountToAdd = (balanceAccount, inputRecurringAllotment, // Usually `balanceAccount.recurringAllotment` is passed in
inputRecurringCap) => {
    if (!balanceAccount)
        return 0;
    const { realtimeRecurringBalance } = (0, exports.calcRealtimeBalanceInfo)(balanceAccount);
    const defaultRecurringAllotment = balanceAccount.type === 'TEAM' ? exports.DEFAULT_TEAM_RECURRING_ALLOTMENT : exports.DEFAULT_CREATORS_CLUB_RECURRING_ALLOTMENT;
    const defaultRecurringCap = balanceAccount.type === 'TEAM' ? exports.DEFAULT_TEAM_RECURRING_CAP : exports.DEFAULT_CREATORS_CLUB_RECURRING_CAP;
    const recurringAllotment = inputRecurringAllotment >= 0
        ? inputRecurringAllotment
        : defaultRecurringAllotment;
    const recurringCap = inputRecurringCap >= 0
        ? inputRecurringCap
        : defaultRecurringCap;
    return (0, lodash_1.clamp)(recurringCap - realtimeRecurringBalance, 0, recurringAllotment);
};
exports.determineRecurringBalanceAmountToAdd = determineRecurringBalanceAmountToAdd;
const determineRecurringRunnitTokensToAdd = (balanceAccount, recurringRunnitTokensAllotment, recurringRunnitTokensCap) => {
    const { realtimeRunnitTokens } = (0, exports.calcRealtimeBalanceInfo)(balanceAccount);
    const recurringAllotment = recurringRunnitTokensAllotment || 0;
    const recurringCap = recurringRunnitTokensCap || 0;
    return (0, lodash_1.clamp)(recurringCap - realtimeRunnitTokens, 0, recurringAllotment);
};
exports.determineRecurringRunnitTokensToAdd = determineRecurringRunnitTokensToAdd;
/**
 * How an enterprise team's token balance reads as USAGE. Enterprise teams count up: their balance
 * is topped up to the budget at each renewal and spent down, going negative when a "Can Exceed"
 * team overdraws, so the number worth showing is how much has been spent, not what is left.
 *
 * The one definition behind every surface that shows it (the Runnits side-nav card and dialog, the
 * team dashboard card, the company teams table), so they can never disagree. Everything is in
 * hundredths; callers convert with hundredthsToTokens.
 *
 * `basis` is what the team had to spend THIS cycle: cycleRunnitTokensBasis, opened at renewal at
 * what the team holds once funded (renewalCycleRunnitTokensBasis), and moved only by transfers, so
 * neither a transfer nor a mid-cycle budget edit (aimed at the next reset) can rewrite how much the
 * team appears to have spent.
 *
 * The stored basis is below zero when the cycle opened in debt: the reset's company bank could not
 * cover the team's overdraw (renewalCycleRunnitTokensBasis). `used` counts from the stored value, so
 * that debt never reads as this cycle's usage. It stays in the overage, still owed, and
 * `carriedOverage` says how much of the overage it is. `basis` itself floors at 0, since the rings
 * and meters divide by it and a negative denominator has no meaning.
 *
 * An account with no basis has no record of what it started the cycle with, so it counts only an
 * overdraw as used: its basis is what it holds now. That is exact for the teams that reach this
 * point, which are new ones nothing has funded or stamped yet (a company converted to enterprise by
 * hand, whose first team was created on a team plan). Guessing the live budget instead invented
 * usage for them: a new team with a 60,000 budget and no tokens read "60,000 used", and its first
 * transfer then locked that phantom usage into the basis it opened. A stamped 0 is a real answer
 * (nothing to spend yet) and does not fall back.
 *
 * A nil account reads as nothing used rather than the budget: the stores hydrate asynchronously,
 * and "3,000,000 used" for a doc that has not landed would be a fabrication. Callers gate on their
 * own loading flags.
 *
 * isOver and isPausedOut are judged on whole displayed tokens, through the same converter every
 * balance is shown with, so a half-token overdraw never paints a red "0 used".
 */
const calcEnterpriseTokenUsage = (balanceAccount, team) => {
    const isBoundToBudget = !!(0, lodash_1.get)(team, 'allotmentSettings.isBoundToBudget');
    if (!balanceAccount) {
        return { remaining: 0, basis: 0, used: 0, overage: 0, carriedOverage: 0, isBoundToBudget, isOver: false, isPausedOut: false };
    }
    const { realtimeRunnitTokens } = (0, exports.calcRealtimeBalanceInfo)(balanceAccount);
    const remaining = realtimeRunnitTokens || 0;
    const frozenBasis = (0, lodash_1.get)(balanceAccount, 'cycleRunnitTokensBasis');
    const cycleBasis = (0, lodash_1.isNil)(frozenBasis) ? Math.max(remaining, 0) : frozenBasis;
    const used = Math.max(cycleBasis - remaining, 0);
    const overage = Math.max(-remaining, 0);
    return {
        remaining,
        basis: Math.max(cycleBasis, 0),
        used,
        overage,
        // Capped at the overage: a team holding tokens owes nothing, whatever its basis says
        carriedOverage: Math.min(Math.max(-cycleBasis, 0), overage),
        isBoundToBudget,
        isOver: (0, pricing_1.hundredthsToTokens)(overage) > 0,
        isPausedOut: isBoundToBudget && (0, pricing_1.hundredthsToTokens)(remaining) < 1,
    };
};
exports.calcEnterpriseTokenUsage = calcEnterpriseTokenUsage;
/**
 * The basis an enterprise renewal opens for the new cycle: what the team actually holds once the
 * renewal has funded it, in hundredths.
 *
 * For a team that spent down, that is its budget (the award tops it back up), and for one that went
 * over, too (the award covers the overage first). But renewals top up and never take tokens back,
 * so a team that already holds more than its budget keeps the surplus and is awarded nothing.
 * Stamping the budget there hid every token spent from the surplus: a budget-0 team funded by a
 * transfer read "0 used" however much it generated.
 *
 * Not floored at 0. A renewal the company bank cannot fully fund leaves the team below zero, and the
 * basis opens there with it, so the new cycle starts at nothing used and the unpaid debt reads as an
 * overage carried over from last cycle (calcEnterpriseTokenUsage). Flooring it counted last cycle's
 * overdraw as this cycle's usage: a team 638,082 over at a reset its empty bank could not cover
 * started the new month at "638,082 used", and the transfer that paid the debt off left it there.
 */
const renewalCycleRunnitTokensBasis = (realtimeRunnitTokensBeforeAward, runnitTokensAwarded) => {
    return (realtimeRunnitTokensBeforeAward || 0) + (runnitTokensAwarded || 0);
};
exports.renewalCycleRunnitTokensBasis = renewalCycleRunnitTokensBasis;
/**
 * The basis to open when a transfer reaches an enterprise team that has none yet (a new team that
 * nothing has funded or stamped, such as the first team of a company converted to enterprise by
 * hand), in hundredths.
 *
 * A transfer is not usage, so the basis opens wherever it leaves the team's displayed "used"
 * exactly as it was: used before the transfer, plus the balance after it. From then on spending
 * counts. Without it, a transfer into such a team was invisible to "used". "Used before" is only
 * the overdraw (see calcEnterpriseTokenUsage), so a team that was never funded opens at exactly
 * what the transfer gives it; while "used" fell back to the live budget, a 60,000-budget team's
 * first 60,000 transfer opened at 120,000 and read 60,000 used with nothing spent.
 *
 * Teams that already have a basis move it by the transfer instead (FieldValue.increment in
 * transferTeamTokens), which keeps "used" unchanged the same way without a read-modify-write.
 *
 * tokensToTeam is signed: positive for tokens from the company bank, negative for a claw-back.
 */
const openingCycleRunnitTokensBasisForTransfer = (balanceAccount, team, tokensToTeam) => {
    const usage = (0, exports.calcEnterpriseTokenUsage)(balanceAccount, team);
    return Math.max(usage.used + usage.remaining + (tokensToTeam || 0), 0);
};
exports.openingCycleRunnitTokensBasisForTransfer = openingCycleRunnitTokensBasisForTransfer;
/*
Auto top-up + one-cycle rollover of purchased top-up tokens
*/
exports.AUTO_TOP_UP_COOLDOWN_MINUTES = 10;
exports.AUTO_TOP_UP_PROCESSING_STALE_MINUTES = 10;
/**
 * Whether a token balance has fallen below an auto top-up threshold — the one question behind every
 * auto top-up, asked in the same terms the user sees it. Both sides go through hundredthsToTokens,
 * the converter every displayed token balance and threshold uses, so this compares the two whole numbers
 * on the screen.
 *
 * In raw hundredths the answer only matched while the threshold was a whole number of tokens: at a
 * 4,999.50 threshold, a 4,999.00 balance counted as below and charged, though both display as
 * "4,999". The slider only ever saves whole thresholds, but nothing else stops a fractional one.
 *
 * Shared by the settings save (the immediate top-up it discloses), the executor's claim, the cron's
 * gate and the settings form's "this will charge now" preview, so no two of them can disagree.
 */
const isBelowAutoTopUpThreshold = (tokenBalanceHundredths, thresholdHundredths) => (0, pricing_1.hundredthsToTokens)(tokenBalanceHundredths) < (0, pricing_1.hundredthsToTokens)(thresholdHundredths);
exports.isBelowAutoTopUpThreshold = isBelowAutoTopUpThreshold;
/**
 * Monthly-renewal award with one-cycle rollover of purchased top-up tokens.
 *
 * Buckets: P = purchasedRunnitTokensThisCycle (top-up purchases since last renewal),
 * R = rolloverRunnitTokens (carried at the last renewal). Only these tracked buckets ever
 * expire — base/upgrade/legacy surplus is preserved exactly like the pre-rollover behavior.
 * Purchases are attributed as spent LAST, so whatever part of P is still held carries into
 * the next cycle; whatever part of R is still held expires now (its second renewal).
 *
 * Nil P (account predates tracking): USER accounts seed their current surplus as if purchased
 * this cycle (one grace cycle before it expires); TEAM accounts seed 0 (pre-bought team banks
 * are never retroactively expired).
 *
 * Returns null when the account has no monthly token allotment — those accounts keep today's
 * behavior entirely (nothing awarded, nothing expires).
 */
const computeRenewalRolloverPlan = (balanceAccount, recurringRunnitTokensAllotment) => {
    const allotment = recurringRunnitTokensAllotment || 0;
    if (!balanceAccount || allotment <= 0)
        return null;
    const { realtimeRunnitTokens } = (0, exports.calcRealtimeBalanceInfo)(balanceAccount);
    const rt = Math.max(realtimeRunnitTokens, 0);
    const hasTrackedP = !(0, lodash_1.isNil)(balanceAccount.purchasedRunnitTokensThisCycle);
    const seededP = balanceAccount.type === 'USER' ? Math.max(0, rt - allotment) : 0;
    const P = hasTrackedP ? Math.max(balanceAccount.purchasedRunnitTokensThisCycle || 0, 0) : seededP;
    const R = Math.max(balanceAccount.rolloverRunnitTokens || 0, 0);
    const carryNext = (0, lodash_1.clamp)(P, 0, rt);
    const expire = (0, lodash_1.clamp)(R, 0, rt - carryNext);
    const award = (0, lodash_1.clamp)(allotment + carryNext - (rt - expire), 0, allotment);
    const delta = award - expire;
    return { carryNext, expire, award, delta };
};
exports.computeRenewalRolloverPlan = computeRenewalRolloverPlan;
const determineNextFreeRunnitTokensTopUpAt = (deviceReportUserSignUp) => {
    const timeZone = (0, lodash_1.get)(deviceReportUserSignUp, 'timeZone') || 'America/Detroit';
    // Tonight at 11:59pm in the user's device's time zone
    return moment().tz(timeZone)
        .endOf('day')
        .subtract(1, 'minute');
};
exports.determineNextFreeRunnitTokensTopUpAt = determineNextFreeRunnitTokensTopUpAt;
exports.RUNNIT_PLANS_TOKENS_CONVERSION_PRICE = 0.0006;
const calcRdBalanceToRunnitTokens = (rdBalance, doCeil = false) => {
    const tokensInHundredths = Math[doCeil ? 'ceil' : 'floor'](new bignumber_js_1.default(rdBalance || 0).div(exports.RUNNIT_PLANS_TOKENS_CONVERSION_PRICE).toNumber());
    // Round to nearest whole token (nearest 100 hundredths)
    return Math[doCeil ? 'ceil' : 'floor'](tokensInHundredths / 100) * 100;
};
exports.calcRdBalanceToRunnitTokens = calcRdBalanceToRunnitTokens;
const calcRunnitTokensToRdBalance = (runnitTokens, doCeil = false) => {
    return Math[doCeil ? 'ceil' : 'floor'](new bignumber_js_1.default(runnitTokens || 0).times(exports.RUNNIT_PLANS_TOKENS_CONVERSION_PRICE).toNumber());
};
exports.calcRunnitTokensToRdBalance = calcRunnitTokensToRdBalance;
